import { connect } from 'react-redux'
import get from 'lodash/get'

import {
  getReportsList as onGetReportsList
} from '../../actions/reportsListActions'

const mapStateToProps = (state) => ({
  reportsListDataState: state.reportsList.dataState,
  reportsListData: get(state, ['reportsList', 'data'], []),
  reportsListErrors: get(state, ['reportsList', 'errors'], [])
})

const mapDispatchToProps = {
  onGetReportsList
}

const withReportsList = Component => connect(mapStateToProps, mapDispatchToProps)(Component)

export { withReportsList }